"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/vacancies': {
    title: 'Vacancies',
    view: 'Vacancies',
    "public": true,
    locales: {
      az: '/az/vacancies',
      en: '/en/vacancies',
      ru: '/ru/vacancies'
    }
  },
  '/az/vacancies': {
    ref: '/vacancies',
    lang: 'az',
    title: 'Vakansiyalar'
  },
  '/en/vacancies': {
    ref: '/vacancies',
    lang: 'en',
    title: 'Vacancies'
  },
  '/ru/vacancies': {
    ref: '/vacancies',
    lang: 'ru',
    title: 'Вакансия'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJ0aXRsZSIsInZpZXciLCJsb2NhbGVzIiwiYXoiLCJlbiIsInJ1IiwicmVmIiwibGFuZyIsIl9kZWZhdWx0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjLWNsaWVudC9tb2R1bGVzL1ZhY2FuY3kvVmFjYW5jeVJvdXRlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCByb3V0ZXMgPSB7XG4gICAgJy92YWNhbmNpZXMnOiB7XG4gICAgICAgIHRpdGxlOiAnVmFjYW5jaWVzJyxcbiAgICAgICAgdmlldzogJ1ZhY2FuY2llcycsXG4gICAgICAgIHB1YmxpYzogdHJ1ZSxcbiAgICAgICAgbG9jYWxlczoge1xuICAgICAgICAgICAgYXo6ICcvYXovdmFjYW5jaWVzJyxcbiAgICAgICAgICAgIGVuOiAnL2VuL3ZhY2FuY2llcycsXG4gICAgICAgICAgICBydTogJy9ydS92YWNhbmNpZXMnLFxuICAgICAgICB9XG4gICAgfSxcbiAgICAnL2F6L3ZhY2FuY2llcyc6IHtyZWY6ICcvdmFjYW5jaWVzJywgbGFuZzogJ2F6JywgdGl0bGU6ICdWYWthbnNpeWFsYXInfSxcbiAgICAnL2VuL3ZhY2FuY2llcyc6IHtyZWY6ICcvdmFjYW5jaWVzJywgbGFuZzogJ2VuJywgdGl0bGU6ICdWYWNhbmNpZXMnfSxcbiAgICAnL3J1L3ZhY2FuY2llcyc6IHtyZWY6ICcvdmFjYW5jaWVzJywgbGFuZzogJ3J1JywgdGl0bGU6ICfQktCw0LrQsNC90YHQuNGPJ30sXG59O1xuXG5leHBvcnQgZGVmYXVsdCByb3V0ZXM7XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQU1BLE1BQU0sR0FBRztFQUNYLFlBQVksRUFBRTtJQUNWQyxLQUFLLEVBQUUsV0FBVztJQUNsQkMsSUFBSSxFQUFFLFdBQVc7SUFDakIsVUFBUSxJQUFJO0lBQ1pDLE9BQU8sRUFBRTtNQUNMQyxFQUFFLEVBQUUsZUFBZTtNQUNuQkMsRUFBRSxFQUFFLGVBQWU7TUFDbkJDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUNELGVBQWUsRUFBRTtJQUFDQyxHQUFHLEVBQUUsWUFBWTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBYyxDQUFDO0VBQ3ZFLGVBQWUsRUFBRTtJQUFDTSxHQUFHLEVBQUUsWUFBWTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBVyxDQUFDO0VBQ3BFLGVBQWUsRUFBRTtJQUFDTSxHQUFHLEVBQUUsWUFBWTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBVTtBQUN0RSxDQUFDO0FBQUMsSUFBQVEsUUFBQSxHQUFBQyxPQUFBLGNBRWFWLE1BQU0iLCJpZ25vcmVMaXN0IjpbXX0=